import pushModel from "@/mixin/store/api/pushModel";
import fetchModel from "@/mixin/store/api/fetchModel";

export default {
    actions: {
        pushProductExcel(context, data) {
            return pushModel(context,'media_objects', data, 'updatePushExcel')
        },
        fetchProductExcel(context, id) {
            return fetchModel(context,'media_objects/' + id + '/head', null, 'updateFetchExcel')
        },
        pushProductEditedExcel(context, data) {
            return pushModel(context, 'media_objects/' + data.id + '/import', data.body, 'updateEditedExcel')
        }
    },
    mutations: {
        updatePushExcel(state, data) {
            return state.pushExcelState = data
        },
        updateFetchExcel(state, data) {
            return state.fetchExcelState = data
        },
        updateEditedExcel(state, data) {
            return state.editedExcel = data
        },
    },
    state: {
        pushExcelState: {
            id: null,
        },
        fetchExcelState: {
            fields: [],
            values: [],
        },
        editedExcel: {
            lines: 0
        },
    },
    getters: {
        getProductExcelId(state) {
            return state.pushExcelState.id
        },
        getProductExcelFields(state) {
            return state.fetchExcelState.fields["hydra:member"]
        },
        getProductExcelValues(state) {
            return state.fetchExcelState.values["hydra:member"]
        },
        getProductExcelValuesAmount(state) {
            return state.fetchExcelState.values["hydra:totalItems"]
        },
        getProductEditedExcel(state) {
            return state.editedExcel.lines
        }
    }
}
